export default {
    car_00001: "Bitte geben Sie Gruppename ein",
    car_00002: "Fahrzeug",
    car_00003: "Plug & Charge-Karte erzeugen und bündeln",
    car_00004: "Fahrzeug hinzufügen",
}